import React from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'

import { useSelector } from 'react-redux'

import Header from './layouts/Header'
import Loader from './layouts/Loader'
import ConfirmStop from './components/ConfirmStop'

import Home from './pages/Home'
import Error from './pages/Error'
import Login from './pages/Login'
import Categories from './pages/Categories'
import Products from './pages/Products'
import References from './pages/References'
import Services from './pages/Services'
import Achievments from './pages/Achievments'

import './App.css'

function App() {
    const process = useSelector(state => state.process);

    return process && (
        <React.StrictMode>
            <Router>
                <Header />

                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="*" element={<Error />} />
                    <Route path="/login" element={<Login />} />

                    <Route path="/categories" element={<Categories />} />
                    <Route path="/products" element={<Products />} />
                    <Route path="/references" element={<References />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/achievments" element={<Achievments />} />
                </Routes>

                {process.loader !== 0 && <Loader />}
                {(process.w_modal !== '' || process.w_page !== '') && <ConfirmStop />}
            </Router>
        </React.StrictMode>
    )
}

export default App;